import { Badge } from './ui/badge';
import { ZohoCrmSection } from './services/ZohoCrmSection';
import { ZohoAnalytics } from './services/ZohoAnalytics';
import { ZohoImplementation } from './services/ZohoImplementation';
import { ProcessAutomation } from './services/ProcessAutomation';
import { OngoingSupport } from './services/OngoingSupport';

export function Services() {
  const serviceHighlights = [
    {
      icon: '/assets/zoho-products/zoho-crm.png',
      title: 'Zoho CRM',
      description: 'Sales pipeline management',
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-analytics.png',
      title: 'Zoho Analytics',
      description: 'Business intelligence',
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-books.png',
      title: 'Zoho Books',
      description: 'Financial management',
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-inventory.png',
      title: 'Zoho Inventory',
      description: 'Inventory management',
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-commerce.png',
      title: 'Zoho Commerce',
      description: 'E-commerce platform',
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-mail.png',
      title: 'Zoho Mail',
      description: 'Business email',
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-creator.png',
      title: 'Zoho Creator',
      description: 'Custom applications',
      isCertified: true,
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-flow.png',
      title: 'Zoho Flow',
      description: 'Workflow automation',
      hasOwnBackground: true
    },
    {
      icon: '/assets/zoho-products/zoho-projects.png',
      title: 'Zoho Projects',
      description: 'Project management',
      hasOwnBackground: true
    }
  ];

  return (
    <section id="services" className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <Badge className="mb-4 bg-blue-100 text-blue-800">Our Services</Badge>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Zoho Based Solutions
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            From Zoho CRM and Zoho One to Zoho Analytics, Zoho Books, Zoho Desk, Zoho Inventory, 
            Zoho Commerce, Zoho Mail, and Zoho Creator - we provide end-to-end implementation and 
            automation services to help your business achieve its full potential.
          </p>
        </div>

        {/* Zoho Apps Quick Overview - restored grid layout */}
        <div className="grid grid-cols-3 lg:grid-cols-9 gap-3 lg:gap-4 mb-12 lg:mb-16">
          {serviceHighlights.map((service, index) => (
            <div key={index} className="text-center hover:shadow-md transition-all duration-300 hover:-translate-y-1 relative bg-white rounded-lg p-2 lg:p-3">
              {service.isCertified && (
                <div className="absolute -top-1 -right-1 bg-yellow-400 text-black text-xs font-bold px-1 py-0.5 rounded-full">
                  CERT
                </div>
              )}
              <div className="mb-2 flex justify-center">
                <div className={`p-1.5 lg:p-2 rounded-lg ${service.hasOwnBackground ? 'bg-gray-50' : 'bg-blue-500'} flex items-center justify-center`}>
                  <img
                    src={service.icon}
                    alt={`${service.title} icon`}
                    className="h-6 w-6 lg:h-8 lg:w-8 object-contain"
                  />
                </div>
              </div>
              <h3 className="font-semibold text-gray-900 text-xs mb-1">{service.title}</h3>
              <p className="text-gray-600 text-xs hidden lg:block">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
      
      {/* Individual Service Sections */}
      <ZohoCrmSection />
      <ZohoAnalytics />
      <ZohoImplementation />
      <ProcessAutomation />
      <OngoingSupport />
    </section>
  );
}